import React from 'react'

import { bikeCategories } from "../../../../constants"

import ChipGroup from "../../../../components/search/filters/filterInputs/chipGroup"

const StyleFilterMobile = props => {
   const { currentValues, onSelect } = props

  return (
    <div className="mobile-style-selector">
      <ChipGroup
        chipType='bikeCategories'
        chipData={bikeCategories}
        className='aligned-chip my-2'
        labelKey={"catLabel"}
        valueKey={"catName"}
        iconKey={"catIconUrl"}
        onChange={onSelect}
        selectedChips={currentValues}
      />
    </div>
  )
}

export default StyleFilterMobile